export const environment = {
  // stripeApiUrl: 'http://localhost:3000',//
  stripeApiUrl: 'https://api-dev.mytreeinitiative.com',
  // zerticarbonApiUrl: 'https://api.zerticarbon.com',
  zerticarbonApiUrl: 'https://api-dev.zerticarbon.com',
  zertiIndexerApiUrl: 'https://api-zertindexer.zertifier.com',
  chainId: '80001',
  contractAddress: '0xeeA360eF315c272518e445b0AA3f7571acA9817d'
};
